"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VirtualPage = void 0;
/**
 * Virtual pages for analytic purposes defined in checkout context.
 */ let VirtualPage = exports.VirtualPage = /*#__PURE__*/ function(VirtualPage) {
    /** Shopping bag step */ VirtualPage["Basket"] = "/shopping/basket/shopping-bag-page";
    /** Offers step */ VirtualPage["Offers"] = "/shopping/basket/offers-page";
    /** Review step */ VirtualPage["Review"] = "/shopping/basket/review-page";
    return VirtualPage;
}({});
